import { useState, useEffect } from 'react';

import { InteractionStatus } from '@azure/msal-browser';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Route, Routes, useNavigate } from 'react-router';

import { loginRequest } from '../config/authConfig';
import Calendar from '../pages/Calendar/Calendar';
import Event from '../pages/Event/Event';
import ListContainer from '../pages/Home/ListContainer/ListContainer';
import NotFound from '../pages/NotFound/NotFound';

const PageRoutes = () => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const bypassAuthForE2E = import.meta.env.VITE_E2E === 'true';

  const [loginInitiated, setLoginInitiated] = useState(false);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const { instance } = useMsal();
  const { inProgress } = useMsal();

  useEffect(() => {
    if (inProgress === InteractionStatus.HandleRedirect) {
      setLoginInitiated(true);
      return;
    }
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    setTimeout(() => {
      if (isPageLoaded) {
        return;
      }

      setIsPageLoaded(true);

      if (!isAuthenticated && !loginInitiated && !bypassAuthForE2E) {
        void instance.loginRedirect(loginRequest);
      } else if (isAuthenticated) {
        const fullPath = globalThis.location.pathname + globalThis.location.search;
        void navigate(fullPath, { replace: true });
      }
    }, 200);
  }, [inProgress, isAuthenticated, isPageLoaded, navigate, instance, loginInitiated, bypassAuthForE2E]);

  return (
    <Routes>
      <Route path="/" element={<ListContainer />} />
      <Route path="/calendar" element={<Calendar />} />
      <Route path="/event/:id" element={<Event />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default PageRoutes;
